import { Injectable } from 'angular-ts-decorators';

import { Domain } from '@shared/app/scripts/services/domain';
import type { IConfig } from '@shared/app/scripts/services/config';
import type { IStandardErrorParser } from '@shared/app/scripts/services/standard-error-parser';

/**
 * Service that expose the /contact-us endpoint from spynl
 */
@Injectable('contact')
export class Contact {
  private spynlUrl: string;

  constructor(
    private $q: ng.IQService,
    private $http: ng.IHttpService,
    private standardErrorParser: IStandardErrorParser,
    domain: Domain,
    config: IConfig,
  ) {
    'ngInject';

    this.spynlUrl = '//' + domain.sibling(config.spynlServices);
  }

  /**
   * Sends us a customer information request
   * @param {string} name
   * Required
   * @param {string} email
   * Required
   * @param {string} subject
   * Required
   * @param {string} message
   * Required
   * @param {string} phone
   * Not required
   * @param {string} category
   * Not required
   * @returns {promise} resolves with object containing the response of the http request.
   * Reject with an error message.`
   */
  us(
    name: string,
    email: string,
    subject: string,
    message: string,
    phone: string,
    category?: string,
  ): ng.IPromise<any> {
    return this.$http({
      method: 'POST',
      url: `${this.spynlUrl}/contact-us`,
      data: {
        name,
        email,
        phone,
        subject,
        message,
        category,
      },
    })
      .catch(this.standardErrorParser)
      .then((data) => data)
      .catch((error) => this.$q.reject(error.data.message));
  }
}
